"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LiquidationReason = void 0;
/** @TranslateToRust */
var LiquidationReason;
(function (LiquidationReason) {
    LiquidationReason["MANUAL_USER_ACCOUNT_CLOSURE_REQUEST"] = "manual_user_account_closure_request";
    LiquidationReason["MANUAL_OPS"] = "manual_ops";
    LiquidationReason["AUTO_MARGIN_CALL"] = "auto_margin_call";
    LiquidationReason["AUTO_WIPED_OUT"] = "auto_wiped_out";
    LiquidationReason["AUTO_DELINQUENCY_PAST_DUE_PAYMENT"] = "auto_delinquency_past_due_payment";
})(LiquidationReason || (exports.LiquidationReason = LiquidationReason = {}));
